import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/Logo";
import { scrollToTop } from "@/lib/scroll";

const LegalPage = ({ title, updated, children }) => (
    <div className="grain min-h-screen bg-ink-900 text-white flex flex-col">
        <header className="border-b border-white/10">
            <div className="shell flex items-center justify-between h-16 md:h-20">
                <Logo
                    onClick={(e) => {
                        e.preventDefault();
                        scrollToTop();
                    }}
                />
                <Link
                    to="/"
                    data-testid="legal-back-link"
                    className="inline-flex items-center gap-2 text-sm text-zinc-400 hover:text-white transition-colors"
                >
                    <ArrowLeft className="h-4 w-4" /> Back to site
                </Link>
            </div>
        </header>
        <main className="shell flex-1 py-20 md:py-28">
            <div className="max-w-3xl mx-auto">
                <h1 className="font-serif text-4xl md:text-5xl tracking-tight text-white">
                    {title}
                </h1>
                <p className="mt-4 text-sm text-zinc-500">Last updated: {updated}</p>
                <div className="mt-10 space-y-6 text-base leading-relaxed text-zinc-400">
                    {children}
                </div>
                <p className="mt-12 text-sm text-zinc-500 border-l-2 border-brass-500/50 pl-4">
                    Placeholder content. Replace this page with final legal
                    text before launch.
                </p>
            </div>
        </main>
        <footer className="border-t border-white/10">
            <div className="shell py-8">
                <p className="text-xs text-zinc-600">
                    © 2026 Scalehaus. All rights reserved.
                </p>
            </div>
        </footer>
    </div>
);

export default function Privacy() {
    return (
        <LegalPage title="Privacy Policy" updated="January 2026">
            <p>
                Scalehaus respects your privacy. This page will describe what
                information we collect through this website, how it is used,
                and the choices available to you.
            </p>
            <p>
                Information submitted through the free audit request form is
                used solely to respond to your inquiry and provide the
                requested audit or consultation.
            </p>
            <p>
                Contact: details for privacy inquiries will be listed here.
            </p>
        </LegalPage>
    );
}
